'use strict';

// in viewport test
window.$.fn.inView = function (partial) {
    var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;
    return compareBottom <= viewBottom && compareTop >= viewTop;
};

//centered browser popup
window.$.centeredPopup = function (options) {
    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left,
        dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top,
        width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width,
        height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height,
        left = width / 2 - options.width / 2 + dualScreenLeft,
        top = height / 2 - options.height / 2 + dualScreenTop,
        newWindow = window.open(options.url, options.title, 'scrollbars=yes, width=' + options.width + ', height=' + options.height + ', top=' + top + ', left=' + left);
    if (window.focus) {
        newWindow.focus();
    }
};

//raf polyfill
(function () {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];
    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
    }
    if (!window.requestAnimationFrame) window.requestAnimationFrame = function (callback, element) {
        var currTime = new Date().getTime();
        var timeToCall = Math.max(0, 16 - (currTime - lastTime));
        var id = window.setTimeout(function () {
            callback(currTime + timeToCall);
        }, timeToCall);
        lastTime = currTime + timeToCall;
        return id;
    };
    if (!window.cancelAnimationFrame) window.cancelAnimationFrame = function (id) {
        clearTimeout(id);
    };
})();

// jQuery throttle / debounce - v1.1 - 3/7/2010
// http://benalman.com/projects/jquery-throttle-debounce-plugin/
var $ = window.jQuery,
    jq_throttle;
$.throttle = jq_throttle = function jq_throttle(delay, no_trailing, callback, debounce_mode) {
    var timeout_id,
        last_exec = 0;
    if (typeof no_trailing !== 'boolean') {
        debounce_mode = callback;
        callback = no_trailing;
        no_trailing = undefined;
    }
    function wrapper() {
        var that = this,
            elapsed = +new Date() - last_exec,
            args = arguments;
        function exec() {
            last_exec = +new Date();
            callback.apply(that, args);
        };
        function clear() {
            timeout_id = undefined;
        };
        if (debounce_mode && !timeout_id) {
            exec();
        }
        timeout_id && clearTimeout(timeout_id);
        if (debounce_mode === undefined && elapsed > delay) {
            exec();
        } else if (no_trailing !== true) {
            timeout_id = setTimeout(debounce_mode ? clear : exec, debounce_mode === undefined ? delay - elapsed : delay);
        }
    };
    return wrapper;
};
$.debounce = function (delay, at_begin, callback) {
    return callback === undefined ? jq_throttle(delay, at_begin, false) : jq_throttle(delay, callback, at_begin !== false);
};

/*!
 * hoverIntent v1.8.1 // 2014.08.11 // jQuery v1.9.1+
 * http://briancherne.github.io/jquery-hoverIntent/
 */

;(function ($) {
    'use strict';

    var _cfg = {
        interval: 100,
        sensitivity: 6,
        timeout: 0
    };
    var INSTANCE_COUNT = 0;
    var cX, cY;
    var track = function track(ev) {
        cX = ev.pageX;
        cY = ev.pageY;
    };
    // compares current and previous mouse positions
    var compare = function compare(ev, $el, s, cfg) {
        // compare mouse positions to see if pointer has slowed enough to trigger `over` function
        if (Math.sqrt((s.pX - cX) * (s.pX - cX) + (s.pY - cY) * (s.pY - cY)) < cfg.sensitivity) {
            $el.off(s.event, track);
            delete s.timeoutId;
            // set hoverIntent state as active for this element (permits `out` handler to trigger)
            s.isActive = true;
            // overwrite old mouseenter event coordinates with most recent pointer position
            ev.pageX = cX;ev.pageY = cY;
            // clear coordinate data from state object
            delete s.pX;delete s.pY;
            return cfg.over.apply($el[0], [ev]);
        } else {
            // set previous coordinates for next comparison
            s.pX = cX;s.pY = cY;
            // use self-calling timeout, guarantees intervals are spaced out properly (avoids JavaScript timer bugs)
            s.timeoutId = setTimeout(function () {
                compare(ev, $el, s, cfg);
            }, cfg.interval);
        }
    };

    // triggers given `out` function at configured `timeout` after a mouseleave and clears state
    var delay = function delay(ev, $el, s, out) {
        delete $el.data('hoverIntent')[s.id];
        return out.apply($el[0], [ev]);
    };

    $.fn.hoverIntent = function (handlerIn, handlerOut, selector) {
        // instance ID, used as a key to store and retrieve state information on an element
        var instanceId = INSTANCE_COUNT++;

        // extend the default configuration and parse parameters
        var cfg = $.extend({}, _cfg);
        if ($.isPlainObject(handlerIn)) {
            cfg = $.extend(cfg, handlerIn);
            if (!$.isFunction(cfg.out)) {
                cfg.out = cfg.over;
            }
        } else if ($.isFunction(handlerOut)) {
            cfg = $.extend(cfg, { over: handlerIn, out: handlerOut, selector: selector });
        } else {
            cfg = $.extend(cfg, { over: handlerIn, out: handlerIn, selector: handlerOut });
        }

        // A private function for handling mouse 'hovering'
        var handleHover = function handleHover(e) {
            // cloned event to pass to handlers (copy required for event object to be passed in IE)
            var ev = $.extend({}, e);

            // the current target of the mouse event, wrapped in a jQuery object
            var $el = $(this);

            // read hoverIntent data from element (or initialize if not present)
            var hoverIntentData = $el.data('hoverIntent');
            if (!hoverIntentData) {
                $el.data('hoverIntent', hoverIntentData = {});
            }

            // read per-instance state from element (or initialize if not present)
            var state = hoverIntentData[instanceId];
            if (!state) {
                hoverIntentData[instanceId] = state = { id: instanceId };
            }

            // clear any existing timeout
            if (state.timeoutId) {
                state.timeoutId = clearTimeout(state.timeoutId);
            }

            // namespaced event used to register and unregister mousemove tracking
            var mousemove = state.event = 'mousemove.hoverIntent.hoverIntent' + instanceId;

            // handle the event, based on its type
            if (e.type === 'mouseenter') {
                // do nothing if already active
                if (state.isActive) {
                    return;
                }
                // set "previous" X and Y position based on initial entry point
                state.pX = ev.pageX;state.pY = ev.pageY;
                // update "current" X and Y position based on mousemove
                $el.off(mousemove, track).on(mousemove, track);
                // start polling interval (self-calling timeout) to compare mouse coordinates over time
                state.timeoutId = setTimeout(function () {
                    compare(ev, $el, state, cfg);
                }, cfg.interval);
            } else {
                // "mouseleave"
                // do nothing if not already active
                if (!state.isActive) {
                    return;
                }
                // unbind expensive mousemove event
                $el.off(mousemove, track);
                // if hoverIntent state is true, then call the mouseOut function after the specified delay
                state.timeoutId = setTimeout(function () {
                    delay(ev, $el, state, cfg.out);
                }, cfg.timeout);
            }
        };

        // listen for mouseenter and mouseleave
        return this.on({ 'mouseenter.hoverIntent': handleHover, 'mouseleave.hoverIntent': handleHover }, cfg.selector);
    };
})(jQuery);


//////////////////
// WEBPACK FOOTER
// ./_js/libs/utils.js
// module id = 7
// module chunks = 0